import type { DelayActionUI } from './DeviceActionUI';
import type { DeviceID } from './DeviceID';
import { is_device } from './DeviceID';
import { RUN_SCRIPT_UI_NAME, type RunScriptCommand } from 'src/helpers/device_script_action_helpers';

export type RunScriptActionUI = {
	_type: typeof RUN_SCRIPT_UI_NAME;
	device: DeviceID;
	scriptId: number;
	scriptName?: string;
	command: RunScriptCommand;
	delay?: DelayActionUI;
};

export const is_run_script_action_ui = (obj: unknown): obj is RunScriptActionUI => {
	if (typeof obj !== 'object' || obj === null) {
		return false;
	}
	const action = obj as RunScriptActionUI;
	return (
		action._type === RUN_SCRIPT_UI_NAME &&
		is_device(action.device) &&
		Number.isFinite(Number(action.scriptId)) &&
		typeof action.command === 'string'
	);
};
